import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MenuItem, PrimeIcons } from 'primeng/api';
import { LayoutMenuItemComponent } from '../menuitem/layout-menu-item.component';
import { TranslateService } from '@ngx-translate/core';
import { TranslationLoaderService } from '@/services/translation-loader.service';
import { UserRole } from '@/types/user.types';
import { AuthorizationService } from '@/services/authorization.service';

@Component({
  selector: 'sm-layout-menu',
  standalone: true,
  imports: [CommonModule, LayoutMenuItemComponent, RouterModule],
  templateUrl: `./layout-menu.component.html`,
})
export class LayoutMenuComponent implements OnInit {
  model: MenuItem[] = [];

  translate = inject(TranslateService);
  translationLoader = inject(TranslationLoaderService);
  authorizationService = inject(AuthorizationService);

  ngOnInit() {
    this.model = [
      {
        label: 'sidebar.general',
        items: [
          { label: 'sidebar.generalOverview.overview', icon: PrimeIcons.DESKTOP, routerLink: ['/'] },
          {
            label: 'sidebar.generalOverview.recentActivities',
            icon: PrimeIcons.TH_LARGE,
            routerLink: '/current-tasks',
          },
        ],
      },
      {
        separator: true,
      },
      {
        label: 'sidebar.planificationOverview',
        items: [
          {
            label: 'sidebar.agpm.label',
            icon: PrimeIcons.BRIEFCASE,
            items: [
              {
                label: 'sidebar.agpm.current_notices',
                icon: PrimeIcons.CLOCK,
                routerLink: '/agpm-current-notice',
              },
              {
                label: 'sidebar.agpm.history',
                icon: PrimeIcons.CALENDAR,
                routerLink: ['/agpm-history'],
              },
            ],
          },
          {
            label: 'sidebar.paa.label',
            icon: PrimeIcons.BRIEFCASE,
            items: [
              {
                label: 'sidebar.paa.current_plans',
                icon: PrimeIcons.CLOCK,
                routerLink: ['/paa-current-plans'],
              },
              {
                label: 'sidebar.paa.history',
                icon: PrimeIcons.CALENDAR,
                routerLink: ['/paa-history'],
              },
            ],
          },
          {
            label: 'sidebar.ppm.label',
            icon: PrimeIcons.BRIEFCASE,
            items: [
              {
                label: 'sidebar.ppm.current_plans',
                icon: PrimeIcons.CLOCK,
                routerLink: ['/ppm-current-plans'],
              },
              {
                label: 'sidebar.ppm.history',
                icon: PrimeIcons.CALENDAR,
                routerLink: ['/ppm-history'],
              },
            ],
          },
          {
            label: 'sidebar.meetings.label',
            icon: PrimeIcons.CALENDAR_CLOCK,
            items: [
              {
                label: 'sidebar.meetings.label',
                icon: PrimeIcons.CALENDAR_CLOCK,
                routerLink: ['/meetings'],
                roles: [
                  UserRole.SUPER_ADMIN,
                  UserRole.ADMIN_CENTRAL,
                  UserRole.CNCMP_PER_PLANIFICATEUR,
                  UserRole.CNCMP_SPE_PLANIFICATEUR,
                  UserRole.CPMP_PLANIFICATEUR,
                  UserRole.CPMP_RAPPORTEUR,
                  UserRole.CNCMP_PER_RAPPORTEUR,
                  UserRole.CNCMP_SPE_RAPPORTEUR,
                ],
              },
              {
                label: 'sidebar.meetings.history',
                icon: PrimeIcons.CALENDAR,
                routerLink: ['/meetings-history'],
                roles: [
                  UserRole.SUPER_ADMIN,
                  UserRole.ADMIN_CENTRAL,
                  UserRole.CNCMP_PER_PLANIFICATEUR,
                  UserRole.CNCMP_SPE_PLANIFICATEUR,
                  UserRole.CPMP_PLANIFICATEUR,
                  UserRole.CPMP_RAPPORTEUR,
                  UserRole.CNCMP_PER_RAPPORTEUR,
                  UserRole.CNCMP_SPE_RAPPORTEUR,
                  UserRole.BACKOFFICE_USER,
                ],
              },
            ],
          },
        ],
      },
      {
        separator: true,
      },
      {
        label: 'sidebar.callForTender.title',
        routerLink: ['/call-for-tender'],
        items: [
          {
            label: 'sidebar.callForTender.callForTender',
            icon: PrimeIcons.MEGAPHONE,
            routerLink: ['/call-for-tender'],
          },
                {
        label: 'sidebar.clarification.parent',
        icon: PrimeIcons.QUESTION_CIRCLE,
        items: [
          {
            label: 'sidebar.clarification.label',
            icon: PrimeIcons.CLOCK,
            routerLink: ['/clarification'],
          },
          {
            label: 'clarification.outputs',
            icon: PrimeIcons.FILE_EDIT,
            routerLink: ['/outputs'],
          },
        ],
      },
      {
        label: 'clarification.reports.plural',
        icon: PrimeIcons.FOLDER,
        items: [
          {
            label: 'sidebar.clarification.report_request',
            icon: PrimeIcons.FILE,
            routerLink: ['/reports'],
            roles: [
              UserRole.SUPER_ADMIN,
              UserRole.ADMIN_CENTRAL,
              UserRole.ADMIN_AC,
              UserRole.REDACTEUR_AC,
              UserRole.VALIDATEUR_AC,
              UserRole.CNCMP_PER_AFFECTATION,
              UserRole.CNCMP_PER_PLANIFICATEUR,
              UserRole.CNCMP_SPE_PLANIFICATEUR,
              UserRole.CPMP_PLANIFICATEUR,
              UserRole.CPMP_RAPPORTEUR,
              UserRole.CNCMP_PER_RAPPORTEUR,
              UserRole.CNCMP_SPE_RAPPORTEUR,
              UserRole.CNCMP_SPE_AFFECTATION,
              UserRole.PUB_AC,
            ],
          },
          {
            label: 'sidebar.clarification.outputs',
            icon: PrimeIcons.FILE_EDIT,
            routerLink: ['/report-request'],
            roles: [
              UserRole.SUPER_ADMIN,
              UserRole.ADMIN_CENTRAL,
              UserRole.ADMIN_AC,
              UserRole.REDACTEUR_AC,
              UserRole.VALIDATEUR_AC,
              UserRole.CNCMP_PER_AFFECTATION,
              UserRole.CNCMP_PER_PLANIFICATEUR,
              UserRole.CNCMP_SPE_PLANIFICATEUR,
              UserRole.CPMP_PLANIFICATEUR,
              UserRole.CPMP_RAPPORTEUR,
              UserRole.CPMP_FILTRATION,
              UserRole.CNCMP_PER_RAPPORTEUR,
              UserRole.CNCMP_SPE_RAPPORTEUR,
              UserRole.CNCMP_SPE_AFFECTATION,
              UserRole.PUB_AC,
              UserRole.BACKOFFICE_USER
            ],
          },
        ],
      }
        ],
      },
      {
        separator: true,
      },
      {
        label: 'sidebar.settings.title',
        routerLink: ['/settings'],
        roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN_CENTRAL, UserRole.ADMIN_AC],
        items: [
          {
            label: 'sidebar.settings.menu.userInfo',
            icon: PrimeIcons.USER_EDIT,
            routerLink: ['/settings/user'],
            roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN_CENTRAL, UserRole.ADMIN_AC],
          },
          {
            label: 'sidebar.settings.menu.contractingAuthorities.label',
            icon: PrimeIcons.WAREHOUSE,
            routerLink: ['/settings/contracting-authority'],
            roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN_CENTRAL, UserRole.ADMIN_AC],
          },
          {
            label: 'sidebar.settings.menu.inscription.title',
            icon: PrimeIcons.BUILDING,
            roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN_CENTRAL, UserRole.ADMIN_AC],
            items: [
              {
                label: 'sidebar.settings.menu.inscription.companyInfo',
                icon: PrimeIcons.COMPASS,
                routerLink: ['/settings/company'],
                roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN_CENTRAL],
              },
              {
                label: 'sidebar.settings.menu.inscription.requestsList',
                icon: PrimeIcons.LIST,
                routerLink: ['/settings/requests-list'],
                roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN_CENTRAL],
              },
              {
                label: 'sidebar.settings.menu.inscription.blackList',
                icon: PrimeIcons.LIST,
                routerLink: ['/settings/requests-list', 'blacklist'],
                roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN_CENTRAL],
              },
              {
                label: 'sidebar.settings.menu.inscription.submittedBids',
                icon: PrimeIcons.LIST,
                routerLink: ['/settings/submitted-bids'],
              },
              {
                label: 'sidebar.settings.menu.inscription.downloadedDacs',
                icon: PrimeIcons.DOWNLOAD,
                routerLink: ['/settings/downloaded-dacs'],
              },

              {
                label: 'settings.paymentJustification.title',
                icon: PrimeIcons.MONEY_BILL,
                routerLink: ['/settings/payment-justification'],
                roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN_CENTRAL, UserRole.ADMIN_AC],
              },
            ],
          },
          {
            label: 'sidebar.settings.menu.committees',
            icon: PrimeIcons.USERS,
            routerLink: ['/settings/committee'],
            roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN_CENTRAL],
          },
          {
            label: 'sidebar.settings.menu.system.title',
            icon: PrimeIcons.WRENCH,
            roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN_CENTRAL],
            items: [
              {
                label: 'sidebar.settings.menu.system.refParams',
                icon: PrimeIcons.WRENCH,
                routerLink: ['/settings/ref-params'],
              },
              {
                label: 'sidebar.settings.menu.system.currency',
                icon: PrimeIcons.MONEY_BILL,
                routerLink: ['/settings/currency'],
              },
              {
                label: 'sidebar.settings.menu.system.passingMode',
                icon: PrimeIcons.CALENDAR,
                routerLink: ['/settings/passing-mode'],
              },
              {
                label: 'sidebar.settings.menu.system.delaisReglementaires',
                icon: PrimeIcons.CLOCK,
                routerLink: ['/settings/delais-reglementaires'],
              },
              {
                label: 'sidebar.settings.menu.system.seuilsGlobal',
                icon: PrimeIcons.CHART_BAR,
                routerLink: ['/settings/seuils'],
              },
              {
                label: 'sidebar.settings.menu.system.activities',
                icon: PrimeIcons.BRIEFCASE,
                routerLink: ['/settings/activities'],
              },
              {
                label: 'sidebar.settings.menu.system.approvalTypes',
                icon: PrimeIcons.BRIEFCASE,
                routerLink: ['/settings/approval-types'],
              },
              {
                label: 'sidebar.settings.menu.system.fundingSources',
                icon: PrimeIcons.MONEY_BILL,
                routerLink: ['/settings/funding-sources'],
              },
            ],
          },
          {
            label: 'sidebar.settings.menu.document.title',
            icon: PrimeIcons.FOLDER,
            roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN_CENTRAL],
            items: [
              {
                label: 'sidebar.settings.menu.document.dynamicDocuments',
                icon: PrimeIcons.FILE,
                routerLink: ['/settings/document-dynamics'],
              },
              {
                label: 'sidebar.settings.menu.document.generalParameters',
                icon: PrimeIcons.FILE_PLUS,
                routerLink: ['/settings/general-parameters'],
              },
              {
                label: 'sidebar.settings.menu.document.transanctionalForm',
                icon: PrimeIcons.QUESTION,
                routerLink: ['/settings/dynamic-forms'],
              },
              {
                label: 'sidebar.settings.menu.system.docSubmission',
                icon: PrimeIcons.FOLDER,
                routerLink: ['/settings/doc-submission'],
              },
              {
                label: 'sidebar.settings.menu.document.dynaDocsModels',
                icon: PrimeIcons.COG,
                routerLink: ['/settings/dyna-docs-models'],
              },
              {
                label: 'sidebar.settings.menu.document.dacScenarios',
                icon: PrimeIcons.COMPASS,
                routerLink: ['/settings/dac-scenarios'],
              },
            ],
          },
          {
            label: 'sidebar.settings.menu.emailTrace',
            icon: PrimeIcons.ENVELOPE,
            routerLink: ['/settings/email-trace'],
            roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN_CENTRAL],
          },
        ],
      },
      // {
      //   label: 'Dev support',
      //   routerLink: ['/settings'],
      //   items: [
      //     {
      //       label: 'Forms',
      //       icon: 'pi pi-fw pi-expand',
      //       routerLink: ['/form-test'],
      //     },
      //     {
      //       label: 'Data Tables',
      //       icon: 'pi pi-fw pi-table',
      //       routerLink: ['/datatable-test'],
      //     },
      //   ],
      // },
    ];
    this.model = this.model
      .filter(item => this.hasAccess(item))
      .map(item => ({
        ...item,
        items: item.items ? this.filterMenu(item.items) : undefined,
      }));
  }

  filterMenu(items: MenuItem[]): MenuItem[] {
    return items
      .filter(item => this.hasAccess(item))
      .map(item => ({
        ...item,
        items: item.items ? this.filterMenu(item.items) : undefined,
      }));
  }

  private hasAccess(item: MenuItem): boolean {
    if (!item['roles']) return true;
    return item['roles'].some((role: string) => this.authorizationService.hasRole(role));
  }
}
